import { useDefault } from '../../../common/common';
import { EarningType } from '../../model/user/earning-type.model';
import { MemberProgramType } from '../../model/user/member-program-type.model';
import { MemberProgram } from '../../model/user/member-program.model';
import { UserStatusType } from '../../model/user/user-status-type.model';
import { User } from '../../model/user/user.model';

const ZERO_POINTS = 0;
export class UserModelBuilder {
  private _model: User;
  constructor() {
    this._model =  new User(UserStatusType.ANONYMOUS);
  }

  withStatus(status: UserStatusType): UserModelBuilder {
    this._model.loginStatus = status;
    return this;
  }

  withMemberData(memberData): UserModelBuilder {
    this._model.rewardsClubNumber = memberData.rewardsClubMemberNumber;
    this._model.firstName = memberData.name.firstName;
    this._model.lastName = memberData.name.lastName;
    this._model.isEmployee = useDefault(memberData.isIHGEmployee, false);
    for (const programData of useDefault(memberData.programs, [])) {
      const programType = MemberProgramType.fromString(programData.programCode);
      const earningPreference = EarningType.fromString(programData.earningType);
      this._model.memberPrograms.push(new MemberProgram(programType, earningPreference));
      if (programType === MemberProgramType.REWARDS_CLUB) {
        this._model.accountBalance = programData.currentPointsBalance
      }
    }
    return this;
  }

  withEnrollmentData(data): UserModelBuilder {
    const enrollmentData = useDefault(data.enroll || data.enrollment, {});
    const reservationData = useDefault(data.hotelReservation, {});
    const guestData = useDefault(reservationData.guest, {});

    this._model.rewardsClubNumber = enrollmentData.memberNumber;
    this._model.pin = enrollmentData.temporaryPin;
    this._model.accountBalance = ZERO_POINTS;
    this._model.firstName = guestData.firstName;
    this._model.lastName = guestData.lastName;
    return this;
  }

  withMemberPageData(memberData): UserModelBuilder {
    const pageData = useDefault(memberData.walletProfile, {});
    const earningPreference: EarningType = EarningType.fromString(useDefault(memberData.earningPreference, '').toUpperCase());
    this._model.rewardsClubNumber = pageData.priorityClubNumber;
    this._model.firstName = pageData.firstName;
    this._model.lastName = pageData.lastName;
    this._model.memberPrograms.push(new MemberProgram(MemberProgramType.REWARDS_CLUB, earningPreference));
    if (memberData.ambassadorMember) {
      this._model.memberPrograms.push(new MemberProgram(MemberProgramType.AMBASSADOR));
    }
    return this;
  }
  build(): User {
    return this._model;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/user-model.builder.ts